var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex", attrs: { id: "finance-base" } }, [
    _c("div", { staticClass: "flex flex-col flex-grow" }, [
      _c(
        "div",
        {
          staticClass:
            "sticky left-0 z-50 flex items-center flex-shrink-0 px-6 border-b top-18 h-18 bg-pure-white border-slate-400",
          style: { width: "calc(100vw - 0.5rem)" },
          attrs: { id: "finance-header" }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [_c("BlTextTitle3", { attrs: { text: "Finance" } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "finance-body" } }, [_c("CreditsManagement")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b54b225", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b54b225","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/Finance.vue
// module id = null
// module chunks = 